import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import "./style.scss";
import { PacmanLoader } from "react-spinners";
import { addNewAddress, getAllMyAddress } from "services/user/orderService";
import {
  getMyInfor,
  setDefaultAddressByID,
  updateUserInfor,
  changePassword,
  updateShippingAddress,
  deleteAddress,
  setPassword,
  getMyAccountBank,
  checkIfUserHasBankAccount,
  getAllBanks,
  updateBankAccount,
  addBankAccount,
  deleteBankAccount
} from "services/user/userService";
import { FaUserCircle } from "react-icons/fa";
import { checkIfUserHasPassword } from "services/user/userService";
import Swal from "sweetalert2";
import { IoIosCloseCircle } from "react-icons/io";
import {
  getProvinces,
  getDistricts,
  getWards,
} from "services/user/orderService";

const PersonalInfor = () => {
  const token = localStorage.getItem("token");
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(false);
  const [selectedAddress, setSelectedAddress] = useState(null);
  const [selectedAddressID, setSelectedAddressID] = useState(null);
  const [formMode, setFormMode] = useState("");
  const [defaultAddress, setDefaultAddress] = useState(null);
  const [allAddress, setAllAddress] = useState([]);
  const [editingAddress, setEditingAddress] = useState(null);
  const [newAddress, setNewAddress] = useState("");
  const [isPasswordExist, setIsPasswordExist] = useState("");
  const [isAddressFormVisible, setIsAddressFormVisible] = useState(false);
  const [provinces, setProvinces] = useState([]);
  const [districts, setDistricts] = useState([]);
  const [wards, setWards] = useState([]);
  const [selectedDistrictId, setSelectedDistrictId] = useState("");
  const [selectedWardId, setSelectedWardId] = useState("");
  const [selectedProvinceId, setSelectedProvinceId] = useState("");
  const [selectedDistrict, setSelectedDistrict] = useState("");
  const [selectedWard, setSelectedWard] = useState("");
  const [isFormVisible, setIsFormVisible] = useState(false);
  const [bankAccount, setBankAccount] = useState(null);
  const [hasBankAccount, setHasBankAccount] = useState(null);
  // State lưu trữ giá trị input
  const [oldPassword, setOldPassword] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [userInfo, setUserInfo] = useState({
    name: "",
    email: "",
    phone: "",
    avatar: "https://cdn-icons-png.flaticon.com/512/6596/6596121.png",
  });

  const [isModalOpen, setIsModalOpen] = useState(false);
  const [accountBankInfor, setAccountBankInfor] = useState({
    bankID: "",
    bankName: "",
    bankShortName: "",
    accountNumber: "",
    accountName: "",
  });

  const [banks, setBanks] = useState([]);

  const [isEditing, setIsEditing] = useState(false);  
const [isAdding, setIsAdding] = useState(false);

  useEffect(() => {
    const fetchBanks = async () => {
      try {
        const response = await getAllBanks(); // API giả định
        setBanks(response.data);
      } catch (error) {
        console.error("Lỗi khi lấy danh sách ngân hàng:", error);
      }
    };
    fetchBanks();
  }, []);

  useEffect(() => {
    const fetchProvinces = async () => {
      try {
        const response = await getProvinces(); // Gọi API lấy danh sách tỉnh/thành
        console.log("Provinces data:", response.data); // Kiểm tra dữ liệu trả về từ API
        setProvinces(response.data); // Lưu dữ liệu vào state
      } catch (error) {
        console.error("Error fetching provinces:", error);
      }
    };

    fetchProvinces(); // Gọi hàm fetchProvinces khi component được mount
  }, []);

  useEffect(() => {
    if (selectedAddress?.provinceId) {
      const fetchDistrict = async () => {
        const data = await getDistricts(selectedAddress.provinceId);
        setDistricts(data.data);

        // Tự động tải wards nếu districtId đã có trong selectedAddress
        if (selectedAddress.districtId) {
          const wardsData = await getWards(selectedAddress.districtId);
          setWards(wardsData.data);
        }
      };
      fetchDistrict();
    }
  }, [selectedAddress?.provinceId]);

  //lấy danh sách quận/huyện theo tỉnh
  useEffect(() => {
    if (selectedProvinceId) {
      const fetchDistrict = async () => {
        // console.log("Fetching districts for province:", selectedProvinceId);
        const data = await getDistricts(selectedProvinceId);
        // console.log("Districts data:", data);
        setDistricts(data.data);
        setWards([]); // Clear wards when province changes
      };
      fetchDistrict();
    }
  }, [selectedProvinceId]);
  //lấy danh sách phường/xã theo quận/huyện
  useEffect(() => {
    if (selectedDistrictId) {
      const fetchWards = async () => {
        const data = await getWards(selectedDistrictId);
        setWards(data.data);
      };
      fetchWards();
    }
  }, [selectedDistrictId]);

  useEffect(() => {
    const fetchBankAccounts = async () => {
      try {
        const data = await getMyAccountBank(token);
        const response = await checkIfUserHasBankAccount(token);
        console.log("Dữ liệu tài khoản ngân hàng:", data.data);
        setBankAccount(data.data);
        setHasBankAccount(response.data);
      } catch (error) {
        console.error("Lỗi khi lấy thông tin tài khoản ngân hàng:", error);
      }
    };

    fetchBankAccounts();
  }, []);

  useEffect(() => {
    console.log("Cập nhật bankAccount:", bankAccount); // Kiểm tra giá trị của bankAccount
  }, [bankAccount]);

  useEffect(() => {
    if (!token) {
      navigate("/login");
    } else {
      setIsLoading(true);

      async function fetchUserInfo() {
        try {
          const checkUserHasPass = await checkIfUserHasPassword(token);

          const userResponse = await getMyInfor(token);

          setUserInfo({
            name: userResponse.data.data.fullName,

            email: userResponse.data.data.email,

            phone: userResponse.data.data.phoneNumber,

            avatar:
              userResponse.data.data.avatar ||
              "https://via.placeholder.com/150",
          });

          const addressesResponse = await getAllMyAddress(token);

          setIsPasswordExist(checkUserHasPass.data);

          // console.log("user co địa chi", checkUserHasPass.data);

          // setAllAddress(addressesResponse.data);

          // const foundDefaultAddress = addressesResponse.data.find(

          //   (address) => address.isDefault === true

          // );

          // console.log("dia chi mac dinh", foundDefaultAddress)

          // if (foundDefaultAddress) {

          //   setDefaultAddress(foundDefaultAddress);

          //   setSelectedAddressID(foundDefaultAddress.id);

          // }

          // console.log("địa chỉ", addressesResponse.data);

          if (Array.isArray(addressesResponse.data)) {
            // Cập nhật địa chỉ vào state

            setAllAddress(addressesResponse.data);

            // Tìm địa chỉ mặc định

            const foundDefaultAddress = addressesResponse.data.find(
              (address) => address.default === true
            );

            // In ra địa chỉ mặc định nếu tìm thấy

            if (foundDefaultAddress) {
              console.log("Địa chỉ mặc định:", foundDefaultAddress);
            } else {
              console.log("Không tìm thấy địa chỉ mặc định");
            }
          } else {
            console.error("Dữ liệu không phải là mảng");
          }
        } catch (error) {
          console.error("Error fetching user info or addresses:", error);

          navigate("/login");
        } finally {
          setIsLoading(false);
        }
      }

      fetchUserInfo();
    }
  }, [token, navigate]);

  const handleUpdateUserInfo = async () => {
    try {
      setIsLoading(true);

      const response = await updateUserInfor(
        token,

        userInfo.name,

        userInfo.phone
      );

      if (response.status === 200) {
        Swal.fire({
          icon: "success",

          title: "Cập nhật thông tin thành công!",

          text: "Thông tin cá nhân của bạn đã được cập nhật.",

          confirmButtonColor: "#5e2e86",
        });

        localStorage.setItem("name", userInfo.name);
      }
    } catch (error) {
      console.error("Error updating user info:", error);

      Swal.fire({
        icon: "error",

        title: "Cập nhật thất bại!",

        text: "Có lỗi xảy ra khi cập nhật thông tin. Vui lòng thử lại.",

        confirmButtonColor: "#5e2e86",
      });
    } finally {
      setIsLoading(false);
    }
  };

  const handleAddAddress = () => {
    setFormMode("add"); // Chuyển sang chế độ thêm

    setSelectedAddress({
      receiver: "",

      phoneNumber: "",

      address: "",

      province: "",

      provinceId: "",

      district: "",

      districtId: "",

      ward: "",

      wardId: "",
    }); // Reset selectedAddress

    setSelectedProvinceId("");

    setSelectedDistrictId("");

    setSelectedWardId("");

    setIsAddressFormVisible(true); // Hiển thị form
  };

  const saveAddress = async () => {
    // Kiểm tra xem selectedAddress đã được đồng bộ đầy đủ hay chưa
    const { receiver, phoneNumber, address, province, district, ward } =
      selectedAddress || {};
    console.log("địa chỉ", selectedAddress);
    if (
      !receiver ||
      !phoneNumber ||
      !address ||
      !province ||
      !district ||
      !ward
    ) {
      alert("Vui lòng điền đầy đủ thông tin.");
      return;
    }
    try {
      setIsLoading(true);
      const isDefault = false;
      const response = await addNewAddress(
        token,
        receiver,
        phoneNumber,
        address,
        province,
        district,
        ward,
        isDefault
      );
      console.log("add", response);
      if (response.status === 200) {
        Swal.fire({
          icon: "success",
          title: "Lưu địa chỉ thành công!",
          text: "Địa chỉ của bạn đã được lưu.",
          confirmButtonColor: "#5e2e86", // Tùy chỉnh màu nút
        });

        setAllAddress(response.data.data);
      } else {
        alert("Có lỗi xảy ra khi lưu địa chỉ.");
      }
    } catch (error) {
      console.error("Error saving address", error);

      alert("Có lỗi xảy ra khi lưu địa chỉ.");
    } finally {
      setIsLoading(false);
    }
  };

  //update address

  const updateAddress = async () => {
    const { id, receiver, phoneNumber, address, city, district, ward } =
      selectedAddress || {};

    console.log("địa chỉ update", selectedAddress);
    try {
      setIsLoading(true);

      const isDefault = false;

      const response = await updateShippingAddress(
        token,
        id,
        receiver,
        phoneNumber,
        address,
        city,
        district,
        ward
      );
      if (response.status === 200) {
        Swal.fire({
          icon: "success",
          title: "Chỉnh sửa địa chỉ thành công!",
          text: "Địa chỉ của bạn đã được lưu.",
          confirmButtonColor: "#5e2e86", // Tùy chỉnh màu nút
        });
        setAllAddress(response.data.data);
      } else {
        alert("Có lỗi xảy ra khi lưu địa chỉ.");
      }
    } catch (error) {
      console.error("Error saving address", error);

      alert("Có lỗi xảy ra khi lưu địa chỉ.");
    } finally {
      setIsLoading(false);
    }
  };

  //xóa địa chỉ

  const handleDeleteAddress = async () => {
    const isDefaultAddress = (selectedAddressID) => {
      const selectedAddress = allAddress.find(
        (address) => address.id === selectedAddressID
      );

      return selectedAddress && selectedAddress.default; // Nếu là địa chỉ mặc định thì trả về true
    };

    if (isDefaultAddress(selectedAddressID)) {
      Swal.fire({
        icon: "error",

        title: "Lỗi!",

        text: "Bạn không thể xóa địa chỉ mặc định.",

        confirmButtonColor: "#5e2e86",
      });

      return; // Dừng hàm nếu địa chỉ là mặc định
    }

    try {
      setIsLoading(true);

      console.log("id được chọn", selectedAddressID);

      const response = await deleteAddress(selectedAddressID, token);

      if (response.status === 200) {
        Swal.fire({
          icon: "success",

          title: "Xóa địa chỉ thành công!",

          text: "Địa chỉ của bạn đã được xóa.",

          confirmButtonColor: "#5e2e86",
        });

        setAllAddress((prevAddresses) =>
          prevAddresses.filter((address) => address.id !== selectedAddressID)
        );
      }
    } catch (error) {
      console.log("xóa", error.response);
    } finally {
      setIsLoading(false);
    }
  };

  const handleSetDefaultAddress = async () => {
    console.log("địa chỉ dduwoj chọn", selectedAddressID);

    if (!selectedAddressID) {
      Swal.fire({
        icon: "error",

        title: "Lỗi!",

        text: "Bạn chưa chọn địa chỉ",

        timer: 3000,

        timerProgressBar: true,

        showConfirmButton: false,

        customClass: {
          popup: "my-swal", // Liên kết với lớp CSS
        },
      });

      return;
    }

    try {
      setIsLoading(true); // Bắt đầu loading

      const response = await setDefaultAddressByID(selectedAddressID, token); // Truyền ID của địa chỉ được chọn

      if (response.status === 200) {
        // Nếu thành công, cập nhật trạng thái của địa chỉ mặc định

        const updatedAddresses = allAddress.map((address) =>
          address.id === selectedAddressID
            ? { ...address, default: true }
            : { ...address, default: false }
        );

        setAllAddress(updatedAddresses); // Cập nhật lại danh sách địa chỉ

        Swal.fire({
          icon: "success",

          title: "Địa chỉ mặc định đã được cập nhật!",

          text: "Địa chỉ của bạn đã được đặt làm mặc định.",

          confirmButtonColor: "#5e2e86",
        });
      } else {
        throw new Error("Cập nhật địa chỉ mặc định không thành công");
      }
    } catch (error) {
      // console.error("Lỗi khi đặt địa chỉ mặc định:", error);
      // alert("Có lỗi xảy ra khi đặt địa chỉ mặc định.");
    } finally {
      setIsLoading(false); // Dừng loading
    }
  };

  const handleAddressSelect = (addressId) => {
    const selectedAddr = allAddress.find((addr) => addr.id === addressId);
    setSelectedAddressID(addressId);
    setSelectedAddress({
      ...selectedAddr,
      provinceId: selectedAddr.provinceId,
      districtId: selectedAddr.districtId,
      wardId: selectedAddr.wardId,
    });
  };

  const handleEditAddress = async () => {
    if (!selectedAddress) {
      alert("Vui lòng chọn một địa chỉ để chỉnh sửa.");
      return;
    }
    console.log("Before edit:", selectedAddress);
    // Tìm ID của tỉnh từ tên tỉnh
    const province = provinces.find(
      (prov) => prov.name.toLowerCase() === selectedAddress.city.toLowerCase()
    );
    console.log("id tỉnh", province.id);
    if (!province) {
      console.error(`Không tìm thấy tỉnh: ${selectedAddress.city}`);
    }

    // Gọi API để lấy danh sách quận/huyện của tỉnh
    let districtsByProvince = [];
    try {
      const response = await getDistricts(province.id);
      districtsByProvince = response.data;
      console.log("Danh sách quận/huyện:", districtsByProvince);
    } catch (error) {
      console.error("Lỗi khi lấy danh sách quận/huyện:", error);
      alert("Không thể lấy danh sách quận/huyện. Vui lòng thử lại sau.");
      return;
    }

    // Tìm quận/huyện từ tên quận/huyện trong địa chỉ đã chọn
    const district = districtsByProvince.find(
      (dist) =>
        dist.name.toLowerCase() === selectedAddress.district.toLowerCase()
    );

    console.log("id quận", district.id);

    if (!district) {
      console.error(`Không tìm thấy quận/huyện: ${selectedAddress.district}`);
      return;
    }

    // Tìm ID của phường/xã từ tên phường/xã
    let wardsByDistrict = [];
    try {
      const response = await getWards(district.id);
      wardsByDistrict = response.data;
      console.log("Danh sách phường/xã:", wardsByDistrict);
    } catch (error) {
      console.error("Lỗi khi lấy danh sách phường/xã:", error);
      alert("Không thể lấy danh sách phường/xã. Vui lòng thử lại sau.");
      return;
    }

    // Tìm phường/xã từ tên phường/xã trong địa chỉ đã chọn
    const ward = wardsByDistrict.find(
      (wrd) => wrd.name.toLowerCase() === selectedAddress.ward.toLowerCase()
    );
    console.log("id xã", ward.id);
    if (!ward) {
      console.error(`Không tìm thấy phường/xã: ${selectedAddress.ward}`);
    }

    // Cập nhật lại địa chỉ đã chọn với các ID tìm được

    setSelectedAddress((prev) => ({
      ...prev,
      provinceId: province ? province.id : "",
      districtId: district ? district.id : "",
      wardId: ward ? ward.id : "",
    }));

    setFormMode("edit");

    console.log("Selected address after edit:", selectedAddress);

    setIsAddressFormVisible(true);
  };

  const handleClick = () => {
    setIsFormVisible(true); // Hiển thị form khi click
  };

  const handlePassword = async () => {
    if (newPassword !== confirmPassword) {
      Swal.fire({
        icon: "error",

        title: "Cập nhật thất bại!",

        text: "Mật khẩu mới không trùng nhau",

        confirmButtonColor: "#5e2e86",
      });

      return;
    }

    if (isPasswordExist && !oldPassword) {
      Swal.fire({
        icon: "error",

        title: "Cập nhật thất bại!",

        text: "Bạn chưa nhập mật khẩu cũ",

        confirmButtonColor: "#5e2e86",
      });

      return;
    }

    try {
      setIsLoading(true);

      if (isPasswordExist) {
        const response = await changePassword(token, oldPassword, newPassword);

        if (response.status === 200) {
          Swal.fire({
            icon: "success",

            title: "Đổi mật khẩu thành công!",

            // text: "Địa chỉ của bạn đã được lưu.",

            confirmButtonColor: "#5e2e86", // Tùy chỉnh màu nút
          });
        }
      } else {
        const response = await setPassword(token, newPassword);

        if (response.status === 200) {
          Swal.fire({
            icon: "success",

            title: "Đặt mật khẩu thành công!",

            confirmButtonColor: "#5e2e86", // Tùy chỉnh màu nút
          });

          setIsPasswordExist(true);
        }
      }
    } catch (error) {
      console.error("Có lỗi xảy ra khi thay đổi mật khẩu:", error);
      if (error.status === 400) {
        Swal.fire({
          icon: "error",
          title: "Mật khẩu cũ không đúng!",
          // text: "Địa chỉ của bạn đã được lưu.",
          confirmButtonColor: "#5e2e86", // Tùy chỉnh màu nút
        });
      }
      // alert("Đã có lỗi xảy ra, vui lòng thử lại.");
    } finally {
      setIsLoading(false);
    }

    setIsFormVisible(false);
  };

  const handleInputChange = (event) => {
    const { name, value } = event.target;
    setAccountBankInfor((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };

  const handleBankSelectChange = (event) => {
    const selectedBankName = event.target.value;
    const selectedBank = banks.find((bank) => bank.name === selectedBankName);
    setAccountBankInfor((prev) => ({
      ...prev,
      bankName: selectedBankName,
      bankShortName: selectedBank?.shortName || "",
      bankID: selectedBank?.id || "",
    }));
  };

  const handleSaveChanges = async () => {
    if (isEditing) {
      try {
        const { bankID, bankName, bankShortName, accountNumber, accountName } = accountBankInfor;
        if (!bankID || !bankName || !accountNumber || !accountName) {
          alert("Vui lòng điền đầy đủ thông tin trước khi lưu.");
          return;
        }
        // Gọi API cập nhật tài khoản ngân hàng
        setIsLoading(true)
        const response = await updateBankAccount(
          token,
          bankID,
          bankName,
          bankShortName,
          accountNumber,
          accountName
        );
  
        if (response.status === 200) {
          Swal.fire({
            icon: "success",
            title: "Chỉnh sửa tài khoản ngân hàng thành công!",
            text: "Tài khoản ngân hàng của bạn đã được lưu.",
            confirmButtonColor: "#5e2e86", // Tùy chỉnh màu nút
          });
  
          setBankAccount({
            bankName,
            accountNumber,
            accountName,
            bankShortName,
            bankID
          });
          setIsModalOpen(false);
          
        }
      } catch (error) {
        console.error("Lỗi khi lưu thay đổi:", error);
        alert(
          "Có lỗi xảy ra khi cập nhật tài khoản ngân hàng. Vui lòng thử lại."
        );
      } finally {
        setIsLoading(false)
      }
    } else if (isAdding) {
      try {
        console.log("add tkng", accountBankInfor)
        const { bankID, bankName, bankShortName, accountNumber, accountName } = accountBankInfor;
        if (!bankID || !bankName || !accountNumber || !accountName) {
          alert("Vui lòng điền đầy đủ thông tin trước khi lưu.");
          return;
        }
        // Gọi API cập nhật tài khoản ngân hàng
        setIsLoading(true)
        const response = await addBankAccount(
          token,
          bankID,
          bankName,
          bankShortName,
          accountNumber,
          accountName
        );
  
        if (response.status === 200) {
          Swal.fire({
            icon: "success",
            title: "Thêm khoản ngân hàng thành công!",
            text: "Tài khoản ngân hàng của bạn đã được lưu.",
            confirmButtonColor: "#5e2e86", // Tùy chỉnh màu nút
          });
  
          setBankAccount({
            bankName,
            accountNumber,
            accountName,
            bankShortName,
            bankID
          });
          setIsModalOpen(false);
          setHasBankAccount(true)
          
        }
      } catch (error) {
        console.error("Lỗi khi lưu thay đổi:", error);
        alert(
          "Có lỗi xảy ra khi cập nhật tài khoản ngân hàng. Vui lòng thử lại."
        );
      } finally {
        setIsLoading(false)
      }
    }
    setIsModalOpen(false);
  };


  const handleAddBankAccount = () => {
    setIsAdding(true);
    setAccountBankInfor({
      bankName: '',
      bankShortName: '',
      accountNumber: '',
      accountName: '',
      bankID: '',
    });
    setIsModalOpen(true);
  };

  const handleEditBankAccount = (account) => {
    setIsEditing(true);
    setAccountBankInfor({
      bankName: account.bankName,
      bankShortName: account.bankShortName,
      accountNumber: account.accountNumber,
      accountName: account.accountName,
      bankID: account.bankID,
    });
    setIsModalOpen(true);
  };

  const handleDeleteBankAccount = async () => {
    if (bankAccount) {
      // Hiển thị hộp thoại xác nhận trước khi xóa
      Swal.fire({
        title: 'Bạn có chắc chắn muốn xóa tài khoản này?',
        text: 'Hành động này không thể hoàn tác!',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#d33',
        cancelButtonColor: '#3085d6',
        confirmButtonText: 'Có, xóa tài khoản!',
        cancelButtonText: 'Hủy'
      }).then(async (result) => {
        if (result.isConfirmed) {
          try {
            setIsLoading(true)
            const response = await deleteBankAccount(token); 
            if (response.status === 200) {
              Swal.fire({
                icon: 'success',
                title: 'Xóa tài khoản ngân hàng thành công!',
                text: 'Tài khoản ngân hàng đã được xóa.',
                confirmButtonColor: '#5e2e86',
              });
  
              setBankAccount(false); 
              setHasBankAccount(false)
            }
          } catch (error) {
            console.error('Lỗi khi xóa tài khoản ngân hàng:', error);
            Swal.fire({
              icon: 'error',
              title: 'Có lỗi xảy ra!',
              text: 'Không thể xóa tài khoản ngân hàng. Vui lòng thử lại.',
              confirmButtonColor: '#d33',
            });
          } finally{
            setIsLoading(false)
          }
        }
      });
    } else {
      alert("Vui lòng chọn tài khoản để xóa!");
    }
  };

  return (
    <div className="container">
      <div className="personal-info-container mt-6">
        <div className="profile">
          {/* Thông tin cá nhân */}

          <div className="profile-left">
            <div className="profile-avatar">
              <FaUserCircle />
            </div>

            <div className="profile-details">
              <label>Email:</label>

              <input
                type="email"
                value={userInfo.email}
                onChange={(e) =>
                  setUserInfo({ ...userInfo, email: e.target.value })
                }
                readOnly
                style={{
                  backgroundColor: "#f0f0f0", // Màu nền sáng

                  border: "1px solid #ccc", // Đường viền nhạt

                  cursor: "not-allowed", // Thay đổi con trỏ khi hover
                }}
              />

              <label>Họ tên:</label>

              <input
                type="text"
                value={userInfo.name}
                onChange={(e) =>
                  setUserInfo({ ...userInfo, name: e.target.value })
                }
              />

              <label>Số điện thoại:</label>

              <input
                type="tel"
                value={userInfo.phone}
                onChange={(e) =>
                  setUserInfo({ ...userInfo, phone: e.target.value })
                }
              />

              <div className="address-actions">
                <button className="btn btn-add" onClick={handleUpdateUserInfo}>
                  Cập nhật thông tin
                </button>
              </div>

              <div className="address-actions">
                <button className="btn btn-add" onClick={handleClick}>
                  {isPasswordExist ? "Đổi mật khẩu" : "Đặt mật khẩu"}
                </button>
              </div>
            </div>
          </div>

          {/* Quản lý địa chỉ */}

          <div className="profile-right">
            <h3 className="address-title">Quản lý địa chỉ</h3>

            <div className="chooseAddress">
              {allAddress && allAddress.length > 0 ? (
                allAddress.map((address) => (
                  <div key={address.id} className="address-item">
                    <input
                      className="form-check-input"
                      type="radio"
                      id={`address-${address.id}`}
                      name="selectedAddress"
                      value={address.id}
                      checked={
                        selectedAddress
                          ? selectedAddress.id === address.id
                          : defaultAddress?.id === address.id
                      }
                      onChange={() => handleAddressSelect(address.id)}
                    />

                    <label
                      htmlFor={`address-${address.id}`}
                      className="address-label"
                    >
                      {`${address.receiver}, ${address.phoneNumber}, ${address.address}, ${address.ward}, ${address.district}, ${address.city}`}

                      {address.default && (
                        <span className="default-badge">Mặc định</span> // Thêm nhãn
                      )}
                    </label>
                  </div>
                ))
              ) : (
                <div>Không có địa chỉ nào.</div> // Hiển thị thông báo nếu không có địa chỉ
              )}
            </div>

            <div className="address-actions">
              <button
                className="btn btn-add"
                onClick={() => {
                  setSelectedAddress(null); // Xóa dữ liệu địa chỉ

                  handleAddAddress();
                }}
              >
                Thêm địa chỉ
              </button>

              <button
                className="btn btn-edit"
                onClick={() => {
                  if (selectedAddress) {
                    handleEditAddress();
                  } else {
                    alert("Vui lòng chọn địa chỉ để chỉnh sửa!");
                  }
                }}
              >
                Chỉnh sửa địa chỉ
              </button>

              <button
                className="btn btn-default"
                onClick={handleSetDefaultAddress}
              >
                Đặt làm địa chỉ mặc định
              </button>

              <button className="btn btn-delete" onClick={handleDeleteAddress}>
                Xóa địa chỉ
              </button>
            </div>

            {isAddressFormVisible && (
              <div className="modal-overlay">
                <div className="modal-content">
                  <div className="modal-header">
                    <button
                      className="modal-close"
                      onClick={() => setIsAddressFormVisible(false)}
                    >
                      <IoIosCloseCircle />
                    </button>
                  </div>

                  <h5 className="tieude">
                    {formMode === "add"
                      ? "Thêm địa chỉ mới"
                      : "Chỉnh sửa địa chỉ"}
                  </h5>

                  {/* Các input cho tên và số điện thoại */}

                  <div className="mb-3 d-flex justify-content-between align-items-center">
                    <label htmlFor="name" className="form-label label-width">
                      Tên:
                    </label>

                    <input
                      type="text"
                      className="form-control input-width"
                      id="name"
                      value={selectedAddress?.receiver || ""}
                      onChange={(e) =>
                        setSelectedAddress({
                          ...selectedAddress,

                          receiver: e.target.value,
                        })
                      }
                    />
                  </div>

                  <div className="mb-3 d-flex justify-content-between align-items-center">
                    <label htmlFor="phone" className="form-label label-width">
                      Số điện thoại:
                    </label>

                    <input
                      type="text"
                      className="form-control input-width"
                      id="phone"
                      value={selectedAddress?.phoneNumber || ""}
                      onChange={(e) =>
                        setSelectedAddress({
                          ...selectedAddress,

                          phoneNumber: e.target.value,
                        })
                      }
                    />
                  </div>

                  {/* Các trường tỉnh/thành, quận/huyện, phường/xã */}

                  <div className="mb-3 d-flex justify-content-between align-items-center">
                    <label
                      htmlFor="province"
                      className="form-label label-width"
                    >
                      Tỉnh/Thành:
                    </label>

                    <select
                      id="province"
                      className="form-control input-width"
                      value={selectedAddress.provinceId || ""}
                      onChange={(e) => {
                        const selectedId = e.target.value;
                        const selectedProvince = provinces.find(
                          (prov) => prov.id === selectedId
                        );

                        // Cập nhật selectedAddress và xóa districtId, wardId khi tỉnh thay đổi
                        setSelectedAddress({
                          ...selectedAddress,
                          province: selectedProvince?.name || "",
                          provinceId: selectedId,
                          districtId: "",
                          wardId: "",
                        });

                        setDistricts([]); // Clear districts
                        setWards([]); // Clear wards
                      }}
                    >
                      <option value="">Chọn tỉnh/thành</option>
                      {provinces.map((province) => (
                        <option key={province.id} value={province.id}>
                          {province.name}
                        </option>
                      ))}
                    </select>
                  </div>

                  <div className="mb-3 d-flex justify-content-between align-items-center">
                    <label
                      htmlFor="district"
                      className="form-label label-width"
                    >
                      Quận/Huyện:
                    </label>
                    <select
                      id="district"
                      className="form-control input-width"
                      value={selectedAddress.districtId || ""}
                      onChange={(e) => {
                        const selectedId = e.target.value;
                        const selectedDistrict = districts.find(
                          (district) => district.id === selectedId
                        );

                        setSelectedAddress({
                          ...selectedAddress,
                          district: selectedDistrict?.name || "",
                          districtId: selectedId,
                          wardId: "", // Clear ward when district changes
                        });

                        // Tải wards khi quận/huyện thay đổi
                        const fetchWards = async () => {
                          const wardsData = await getWards(selectedId);
                          setWards(wardsData.data);
                        };
                        fetchWards();
                      }}
                      disabled={!selectedAddress.provinceId} // Disable nếu chưa chọn tỉnh
                    >
                      <option value="">Chọn quận/huyện</option>
                      {districts.map((district) => (
                        <option key={district.id} value={district.id}>
                          {district.name}
                        </option>
                      ))}
                    </select>
                  </div>
                  <div className="mb-3 d-flex justify-content-between align-items-center">
                    <label htmlFor="ward" className="form-label label-width">
                      Phường/Xã:
                    </label>

                    <select
                      id="ward"
                      className="form-control input-width"
                      value={selectedAddress.wardId || ""}
                      onChange={(e) => {
                        const selectedId = e.target.value;
                        const selectedWard = wards.find(
                          (ward) => ward.id === selectedId
                        );

                        setSelectedAddress({
                          ...selectedAddress,
                          ward: selectedWard?.name || "",
                          wardId: selectedId,
                        });
                      }}
                      disabled={!selectedAddress.districtId} // Disable nếu chưa chọn quận/huyện
                    >
                      <option value="">Chọn phường/xã</option>
                      {wards.map((ward) => (
                        <option key={ward.id} value={ward.id}>
                          {ward.name}
                        </option>
                      ))}
                    </select>
                  </div>

                  {/* Địa chỉ */}

                  <div className="mb-3 d-flex justify-content-between align-items-center">
                    <label htmlFor="address" className="form-label label-width">
                      Địa chỉ:
                    </label>

                    <input
                      type="text"
                      className="form-control input-width"
                      id="address"
                      value={selectedAddress?.address || ""}
                      onChange={(e) =>
                        setSelectedAddress({
                          ...selectedAddress,

                          address: e.target.value,
                        })
                      }
                    />
                  </div>

                  <button
                    className="btn save-address"
                    onClick={() => {
                      if (formMode === "edit") {
                        updateAddress(selectedAddress);
                      } else {
                        saveAddress();
                      }

                      setIsAddressFormVisible(false); // Đóng form
                    }}
                  >
                    {formMode === "add"
                      ? "Lưu địa chỉ mới"
                      : "Lưu thay đổi địa chỉ"}
                  </button>
                </div>
              </div>
            )}
          </div>

          <div className="bank-info mt-6">
            <h4 className="title-list-address">Thông tin tài khoản ngân hàng</h4>

            <div className="bank-details">
              {bankAccount ? (
                <div className="bank-account-item">
                  <p>{`${bankAccount.bankName} - ${bankAccount.accountNumber} (${bankAccount.accountName})`}</p>
                </div>
              ) : (
                <div>Chưa có tài khoản ngân hàng nào.</div>
              )}
            </div>

            <div className="bank-actions">
              {!hasBankAccount && (
                <button className="btn btn-add" onClick={handleAddBankAccount}>
                  Thêm tài khoản
                </button>
              )}

              <button
                className="btn btn-edit"
                onClick={() => {
                  if (bankAccount) {
                    handleEditBankAccount(bankAccount);
                  } else {
                    alert("Vui lòng chọn tài khoản để chỉnh sửa!");
                  }
                }}
              >
                Chỉnh sửa tài khoản
              </button>

              <button
                className="btn btn-delete"
                onClick={() => {
                  if (bankAccount) {
                    handleDeleteBankAccount();
                  } else {
                    alert("Vui lòng chọn tài khoản để xóa!");
                  }
                }}
              >
                Xóa tài khoản
              </button>
            </div>
          </div>

          {isModalOpen && (
   <div className="modal-overlay">
              <div className="modal-content">
              <button
                  className="modal-close"
                  onClick={() => setIsModalOpen(false)
              }
                >
                  <IoIosCloseCircle />
                </button>
    <h4 className="title-list-address">{isEditing ? 'Chỉnh sửa tài khoản ngân hàng' : 'Thêm tài khoản ngân hàng'}</h4>
    <label className="input-label">
                  Tên ngân hàng:
    <select
                    className="input-field"
                    name="bankName"
                    value={accountBankInfor.bankName}
                    onChange={handleBankSelectChange}
                  >
                    <option value="">-- Chọn ngân hàng --</option>
                    {banks && banks.length > 0 ? (
                      banks.map((bank, index) => (
                        <option key={index} value={bank.name}>
                          {bank.name}
                        </option>
                      ))
                    ) : (
                      <option value="" disabled>
                        Đang tải danh sách ngân hàng...
                      </option>
                    )}
                  </select>
                </label>

                <label className="input-label">
                  Tên ngắn gọn:
                  <input
                    className="input-field"
                    type="text"
                    name="bankShortName"
                    value={accountBankInfor.bankShortName}
                    readOnly
                  />
                </label>

                <label className="input-label">
                  Số tài khoản:
                  <input
                    className="input-field"
                    type="text"
                    name="accountNumber"
                    value={accountBankInfor.accountNumber}
                    onChange={handleInputChange}
                  />
                </label>

                <label className="input-label">
                  Tên tài khoản:
                  <input
                    className="input-field"
                    type="text"
                    name="accountName"
                    value={accountBankInfor.accountName}
                    onChange={handleInputChange}
                  />
                </label>

    <button className="btn save-address" onClick={handleSaveChanges}>
      {isEditing ? 'Lưu thay đổi' : 'Thêm tài khoản'}
    </button>
  </div>
  </div>
)}

          {isFormVisible && (
            <div className="modal-overlay">
              <div className="modal-content">
                <div className="modal-header">
                  <button
                    className="modal-close"
                    onClick={() => setIsFormVisible(false)}
                  >
                    <IoIosCloseCircle />
                  </button>
                </div>

                <form className="password-form">
                  <h2>{isPasswordExist ? "Đổi mật khẩu" : "Đặt mật khẩu"}</h2>

                  {isPasswordExist && (
                    <div>
                      <label>Mật khẩu cũ:</label>

                      <input
                        type="password"
                        value={oldPassword}
                        onChange={(e) => setOldPassword(e.target.value)}
                      />
                    </div>
                  )}

                  <div>
                    <label>Mật khẩu mới:</label>

                    <input
                      type="password"
                      value={newPassword}
                      onChange={(e) => setNewPassword(e.target.value)}
                    />
                  </div>

                  <div>
                    <label>Xác nhận mật khẩu mới:</label>

                    <input
                      type="password"
                      value={confirmPassword}
                      onChange={(e) => setConfirmPassword(e.target.value)}
                    />
                  </div>

                  <button type="button" onClick={handlePassword}>
                    {isPasswordExist ? "Đổi mật khẩu" : "Đặt mật khẩu"}
                  </button>
                </form>
              </div>
            </div>
          )}
        </div>

        {isLoading && (
          <div className="modal">
            <div className="overlay_loading">
              <div className="modal-content_loading">
                <div className="d-flex">
                  <PacmanLoader color="#5e2e86" />
                </div>
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default PersonalInfor;
